import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

import { AgentNote } from './AgentNote'

export interface CreditLedgerEntry {
  id: string
  cognitoId: string
  amount: number
  reason: string
  addedBy: string
  createdAt: string
}

export type NotificationPreferences = {
  notifyPkgArrived: boolean
  notifyPaymentDue: boolean
  notifyPkgReqAnswered: boolean
  notifyPickupAssigned: boolean
}

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  notifyPkgArrived: true,
  notifyPaymentDue: true,
  notifyPkgReqAnswered: true,
  notifyPickupAssigned: true,
}

export type User = {
  id: string
  name: string
  /** Wallet credit in USD */
  creditBalance: number
  email: string
  phoneNumber: string
  familyName: string
  refBy?: string
  warehouse?: PkgWarehouse
  subscribe: boolean
  isDubaiUser?: boolean
  /** ISO timestamp set when the client onboarding tour is completed. Null for new users. */
  onboardingCompletedAt?: string | null
  notificationPreferences: NotificationPreferences
  deletedAt?: Date
  deletedBy?: string
  creditLedgers: CreditLedgerEntry[]
  notes: AgentNote[]
  updatedAt: string
  createdAt: string
}

export type UserWithCognito = User & {
  isEmailVerified: boolean
}
